<template>
  <div v-if="employee" class="card">
    <div class="card-img_height">
      <img
        v-bind:class="{ blackandwhite: !employee.hasWorkDay }"
        class="card-img-top"
        :src="employee.image"
        v-if="employee.image"
      />
      <img
        v-else
        v-bind:class="{ blackandwhite: !employee.hasWorkDay }"
        class="card-img-top"
        :src="require('../../assets/VanBerlo_logo_dark-grey_RGB_APPLICATIONS.png')"
      />
    </div>
    <div class="card-body">
      <h5>{{ employee.name }}</h5>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmployeeCard",
  props: {
    employee: null
  }
};
</script>

<style>
.card-img_height {
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 200px;
  overflow: hidden;
}
@media (max-width: 778px) {
  .card-img_height {
    min-height: 300px;
    max-height: 300px;
  }
}

.card {
  width: 100%;
}
</style>
